import { render, staticRenderFns } from "./MenuScrollContainer.vue?vue&type=template&id=af594d56&scoped=true"
import script from "./MenuScrollContainer.vue?vue&type=script&lang=js"
export * from "./MenuScrollContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af594d56",
  null
  
)

export default component.exports